import { render, staticRenderFns } from "./FDOList.vue?vue&type=template&id=52d5aa3e&scoped=true&"
import script from "./FDOList.vue?vue&type=script&lang=js&"
export * from "./FDOList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5aa3e",
  null
  
)

export default component.exports